export default __webpack_public_path__ + "static/media/team-member-4.89642355.png";